function initDescriptionAnimation() {
	const cardsBlocks = document.querySelectorAll(
		'.wp-block-metawood-project-categories'
	);
	if (cardsBlocks.length === 0) return;

	cardsBlocks.forEach((cardsBlock) => {
		const cardsContainer = cardsBlock.querySelector(
			'.project-category-cards-container'
		);
		if (!cardsContainer) return;

		const categoryCards = cardsContainer.querySelectorAll(
			'.project-category-card'
		);
		if (categoryCards.length === 0) return;

		let currentlyVisibleDesc = null;

		const masterTimeline = gsap.timeline({ paused: true });

		categoryCards.forEach((categoryCard) => {
			const categorySlug = categoryCard.dataset.category;
			const description = cardsBlock.querySelector(
				`.category-description[data-category="${categorySlug}"]`
			);
			if (!description) return;

			categoryCard.addEventListener('mouseenter', () => {
				if (description === currentlyVisibleDesc) return;

				masterTimeline.clear();

				if (currentlyVisibleDesc) {
					masterTimeline.to(currentlyVisibleDesc, {
						opacity: 0,
						yPercent: -50,
						duration: 0.25,
						ease: 'power2.in',
						onStart: () => {
							currentlyVisibleDesc.setAttribute(
								'aria-visible',
								'true'
							);
						},
						onComplete: () => {
							currentlyVisibleDesc.setAttribute(
								'aria-visible',
								'false'
							);
						},
					});
				}

				masterTimeline.add(() => {
					description.setAttribute('aria-visible', 'true');
					currentlyVisibleDesc = description;
				});
				masterTimeline.fromTo(
					description,
					{ opacity: 0, yPercent: -50 },
					{
						opacity: 1,
						yPercent: 0,
						duration: 0.3,
						ease: 'power2.out',
					}
				);

				masterTimeline.play();
			});

			categoryCard.addEventListener('mouseleave', () => {
				if (description !== currentlyVisibleDesc) return;

				masterTimeline.clear();

				masterTimeline.to(description, {
					opacity: 0,
					yPercent: -50,
					duration: 0.25,
					ease: 'power2.in',
					onComplete: () => {
						description.setAttribute('aria-visible', 'false');
						currentlyVisibleDesc = null;
					},
				});

				masterTimeline.play();
			});
		});
	});
}

document.addEventListener('DOMContentLoaded', () => {
	initDescriptionAnimation();
	window.addEventListener('resize', (e) => {
		if (window.innerWidth >= 768) {
			initDescriptionAnimation();
		}
	});
});
